// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b9f3973","239":"5c70ac19","453":"5d51bf06","455":"975eb410"}[chunkId] + ".chunk.js";
};